import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
	baseURL: API_BASE,
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
});

// Single place to format API errors so callers can safely call toast or setState
// with the result. FastAPI 422 returns `detail` as an array of objects which
// would crash React if rendered directly.
export function formatApiError(err, fallback = 'Something went wrong. Please try again.') {
	const detail = err?.response?.data?.detail;
	if (detail == null) return err?.message || fallback;
	if (typeof detail === 'string') return detail;
	if (Array.isArray(detail)) {
		return detail
			.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
			.filter(Boolean)
			.join(' ') || fallback;
	}
	if (detail && typeof detail.msg === 'string') return detail.msg;
	try {
		return JSON.stringify(detail);
	} catch {
		return fallback;
	}
}

export default api;
